import { render, staticRenderFns } from "./rep_chart_dash.vue?vue&type=template&id=56296470&scoped=true&"
import script from "./rep_chart_dash.vue?vue&type=script&lang=js&"
export * from "./rep_chart_dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56296470",
  null
  
)

export default component.exports